exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remove-assesments-list li{list-style-type:none}.remove-assesments-list li ul{margin:.75em 0;margin-left:2.55em}.remove-assesments-list li ul li{margin:.55em 0}", ""]);

// exports
